export const TOKEN_DATA_KEY = "token-data";
export var RequestScopes;
(function (RequestScopes) {
    RequestScopes["openIdProfile"] = "openid profile";
})(RequestScopes || (RequestScopes = {}));
//perhaps change to boolean?
export var userSessionState;
(function (userSessionState) {
    userSessionState["hasActiveSession"] = "loggedInSuccessfully";
    userSessionState["noActiveSessionFound"] = "noActiveSessionFound";
    userSessionState["loggedOut"] = "loggedOut";
    userSessionState["failedLogout"] = "failedLogout";
})(userSessionState || (userSessionState = {}));
export var GrantTypes;
(function (GrantTypes) {
    GrantTypes["refreshToken"] = "refresh_token";
    GrantTypes["authorizationCode"] = "authorization_code";
})(GrantTypes || (GrantTypes = {}));
//# sourceMappingURL=AMTypes.js.map